import { render, staticRenderFns } from "./sixCollapsible.vue?vue&type=template&id=f9ddeaea&scoped=true&"
import script from "./sixCollapsible.vue?vue&type=script&lang=js&"
export * from "./sixCollapsible.vue?vue&type=script&lang=js&"
import style0 from "./sixCollapsible.vue?vue&type=style&index=0&id=f9ddeaea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ddeaea",
  null
  
)

export default component.exports